export default __webpack_public_path__ + "static/media/devguide02.e2c95525.md";